import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaCrown, FaCheck } from "react-icons/fa";
import {
  TIER_UPGRADE_MESSAGES,
  PREMIUM_BENEFITS,
} from "../constants/subscriptionTiers";
import { queueEvent } from "../analytics";
import { EVENTS } from "../analytics/events";
import { Button, Modal } from "../ui";

// Shown when a free user hits a tier limit.
// Phase 1: the CTA tells the user to subscribe in the mobile app. Phase 2 will
// replace it with a button that navigates to /pricing (MyFatoorah checkout).
const UpgradeModal = ({ isOpen, messageKey = "GENERIC", onClose }) => {
  const navigate = useNavigate();

  // Top of the paywall funnel: a free user hit a gate. Mirrors the app's
  // cta_paywall_shown from requireFeature/requireTier.
  useEffect(() => {
    if (!isOpen) return;
    queueEvent(EVENTS.CTA_PAYWALL_SHOWN, {
      source: messageKey,
      reason: "limit_reached",
    });
  }, [isOpen, messageKey]);

  if (!isOpen) return null;
  const msg =
    TIER_UPGRADE_MESSAGES[messageKey] || TIER_UPGRADE_MESSAGES.GENERIC;

  return (
    <Modal open={isOpen} onClose={onClose} labelledBy="upgrade-title">
      <div className="text-center -mt-4 mb-6">
        <span className="mx-auto mb-4 w-16 h-16 rounded-2xl bg-primary/15 border border-primary/30 text-primary flex items-center justify-center">
          <FaCrown size={30} aria-hidden="true" />
        </span>
        <h2 id="upgrade-title" className="text-2xl font-extrabold">
          {msg.title}
        </h2>
        <p className="text-white/70 mt-2 leading-relaxed">{msg.message}</p>
      </div>

      <div className="rounded-2xl bg-white/[0.05] border border-white/10 p-4 mb-6">
        <p className="text-white/90 text-sm font-bold mb-3">
          ميزات الاشتراك المميز
        </p>
        <ul className="space-y-2.5">
          {PREMIUM_BENEFITS.map((b, i) => (
            <li key={i} className="flex items-center gap-3 text-white/85 text-sm">
              <span className="w-6 h-6 shrink-0 rounded-lg bg-success/15 text-success flex items-center justify-center">
                <FaCheck className="text-[10px]" aria-hidden="true" />
              </span>
              {b.text}
            </li>
          ))}
        </ul>
      </div>

      <Button
        block
        size="lg"
        icon={<FaCrown className="text-base" aria-hidden="true" />}
        onClick={() => {
          queueEvent(EVENTS.CTA_PAYWALL_PRESSED, { source: messageKey });
          onClose();
          // Carries the gate that triggered the upgrade into the paywall
          // events fired by /pricing.
          navigate("/pricing", { state: { source: messageKey } });
        }}
      >
        اشترك الآن
      </Button>
      <Button variant="ghost" block className="mt-2" onClick={onClose}>
        ليس الآن
      </Button>
    </Modal>
  );
};

export default UpgradeModal;
